import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";
import { useState } from "react";

const useGetDealerIvideonById = () => {
  const [params, setParams] = useState<string>();

  const { getIvideonDealers } = useIvideon();

  const getRequestParams = (props: string) => {
    setParams(props);
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getIvideonDealers", params],
    queryFn: () => getIvideonDealers(params!),
    onError: (error) => {
      console.log(error);
    },
    enabled: !!params,
  });
  return { data: data?.data, isLoading, isError, getRequestParams, refetch };
};

export default useGetDealerIvideonById;
